import { PLOTTR_KNOWN_FILES, PRO_KNOWN_FILES } from '../constants/applicationState'
import {
  ADVANCE_PRO_ONBOARDING,
  FINISH_CHECKING_FILE_TO_LOAD,
  FINISH_CHECKING_SESSION,
  FINISH_CREATING_CLOUD_FILE,
  FINISH_DELETING_FILE,
  FINISH_LOADING_A_LICENSE_TYPE,
  FINISH_LOADING_A_SETTINGS_TYPE,
  FINISH_LOADING_FILE,
  ERROR_LOADING_FILE,
  FINISH_LOADING_FILE_LIST,
  FINISH_LOGGING_IN,
  FINISH_ONBOARDING,
  CANCEL_ONBOARDING,
  FINISH_RENAMING_FILE,
  FINISH_SAVING_FILE_AS,
  FINISH_UPLOADING_FILE_TO_CLOUD,
  START_CHECKING_FILE_TO_LOAD,
  START_CHECKING_SESSION,
  START_CREATING_CLOUD_FILE,
  START_DELETING_FILE,
  START_IMPORTING_SCRIVENER,
  FINISH_IMPORTING_SCRIVENER,
  START_LOADING_A_LICENSE_TYPE,
  FINISH_FETCHING_A_LICENSE_TYPE,
  START_LOADING_A_SETTINGS_TYPE,
  START_LOADING_FILE,
  START_LOADING_FILE_LIST,
  START_LOGGING_IN,
  START_ONBOARDING,
  START_ONBOARDING_FROM_ROOT,
  START_RENAMING_FILE,
  START_SAVING_FILE_AS,
  START_UPLOADING_FILE_TO_CLOUD,
  PROMPT_TO_UPLOAD_FILE,
  DISMISS_PROMPT_TO_UPLOAD_FILE,
  REQUEST_CHECK_FOR_UPDATE,
  PROCESS_RESPONSE_TO_REQUEST_UPDATE,
  DISMISS_UPDATE_NOTIFIER,
  SET_UPDATE_DOWNLOAD_PROGRESS,
  AUTO_CHECK_FOR_UPDATES,
  BUSY_WITH_WORK_THAT_PREVENTS_QUITTING,
  DONE_WITH_WORK_THAT_PREVENTS_QUITTING,
  CLEAR_ERROR_LOADING_FILE,
  INCREMENT_JUMP_COUNTER,
  ADVANCE_SETTINGS_WIZARD,
  REGRESS_SETTINGS_WIZARD,
  START_SETTINGS_WIZARD,
  FINISH_PRO_ONBOARDING_HAVING_CHOSEN_PRO,
  FINISH_SETTINGS_WIZARD,
  START_EDITING,
  START_VIEWING,
  START_SEARCHING,
  STAGE_LANGUAGE,
  SET_PATH_TO_PROJECT,
  OPEN_DASHBOARD_TO,
  DASHBOARD_CLOSED,
  FINISH_FIRST_TIME_BOOTING,
  NO_FILE_TO_SHOW,
  START_FILE_IMPORT,
  FINISH_FILE_IMPORT,
  START_QUITTING,
  RECORD_FILE_URL_BOOTED_WITH,
  RECEIVED_WINDOW_STATE,
  SET_ONLINE,
  ADVANCE_BOOTING_DISPLAY_STATE,
  ASK_TO_RECONNECT,
  ASK_TO_LOGIN,
  DIFFICULTY_CONTACTING_LICENSING_API,
  START_FETCHING_A_LICENSE_TYPE,
  SET_FORCE_LICENSE_CHECK,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../index').FileURL} FileURL
 * @typedef {import('../types/system').UpdateInfo} UpdateInfo
 * @typedef {import('plottr_locales').Locale} Locale
 */

/**
 * @typedef {ReturnType<typeof startLoadingFileList> | ReturnType<typeof finishLoadingFileList> | ReturnType<typeof startLoadingPlottrFileList> | ReturnType<typeof finishLoadingPlottrFileList> | ReturnType<typeof startLoadingProFileList> | ReturnType<typeof finishLoadingProFileList> | ReturnType<typeof startCheckingFileToLoad> | ReturnType<typeof finishCheckingFileToLoad> | ReturnType<typeof startCreatingCloudFile> | ReturnType<typeof finishCreatingCloudFile> | ReturnType<typeof startUploadingFileToCloud> | ReturnType<typeof finishUploadingFileToCloud> | ReturnType<typeof startLoadingFile> | ReturnType<typeof finishLoadingFile> | ReturnType<typeof errorLoadingFile> | ReturnType<typeof clearErrorLoadingFile> | ReturnType<typeof startRenamingFile> | ReturnType<typeof finishRenamingFile> | ReturnType<typeof startDeletingFile> | ReturnType<typeof finishDeletingFile> | ReturnType<typeof startSavingFileAs> | ReturnType<typeof finishSavingFileAs> | ReturnType<typeof noFileToShow> | ReturnType<typeof startLoggingIn> | ReturnType<typeof finishLoggingIn> | ReturnType<typeof startCheckingSession> | ReturnType<typeof finishCheckingSession> | ReturnType<typeof startLoadingALicenseType> | ReturnType<typeof finishLoadingALicenseType> | ReturnType<typeof startLoadingASettingsType> | ReturnType<typeof finishLoadingASettingsType> | ReturnType<typeof advanceSettingsWizard> | ReturnType<typeof regressSettingsWizard> | ReturnType<typeof startSettingsWizard> | ReturnType<typeof finishSettingsWizard> | ReturnType<typeof advanceProOnboarding> | ReturnType<typeof startProOnboarding> | ReturnType<typeof finishProOnboarding> | ReturnType<typeof cancelProOnboarding> | ReturnType<typeof startProOnboardingFromRoot> | ReturnType<typeof setForceLicenseCheck> | ReturnType<typeof startScrivenerImporter> | ReturnType<typeof startProjectImporter> | ReturnType<typeof finishScrivenerImporter> | ReturnType<typeof finishProjectImporter> | ReturnType<typeof promptToUploadFile> | ReturnType<typeof dismissPromptToUploadFile> | ReturnType<typeof requestCheckForUpdates> | ReturnType<typeof autoCheckForUpdates> | ReturnType<typeof processResponseToRequestUpdate> | ReturnType<typeof dismissUpdateNotifier> | ReturnType<typeof setUpdateDownloadProgress> | ReturnType<typeof startWorkThatPreventsQuitting> | ReturnType<typeof finishWorkThatPreventsQuitting> | ReturnType<typeof incrementJumpCounter> | ReturnType<typeof startEditing> | ReturnType<typeof startViewing> | ReturnType<typeof startSearching> | ReturnType<typeof stageLanguage> | ReturnType<typeof setPathToProject> | ReturnType<typeof setOpenDashboardTo> | ReturnType<typeof dashboardClosed> | ReturnType<typeof finishFirstTimeBooting> | ReturnType<typeof startQuitting> | ReturnType<typeof recordFileURLBootedWith> | ReturnType<typeof receivedWindowState> | ReturnType<typeof setOnline> | ReturnType<typeof askToReconnect> | ReturnType<typeof askToLogin> | ReturnType<typeof difficultyContactingLicensingAPI> | ReturnType<typeof advanceBootingDisplayState> | ReturnType<typeof startFetchingALicenseType> | ReturnType<typeof finishFetchingALicenseType>} ApplicationStateActions
 */

// Project states
/**
 * @template A
 * @param {A} fileListType
 * @return {{ type: 'START_LOADING_FILE_LIST', fileListType: A}}
 */
const startLoadingFileList = (fileListType) => ({
  type: START_LOADING_FILE_LIST,
  fileListType,
})
/**
 * @template A
 * @param {A} fileListType
 * @return {{ type: 'FINISH_LOADING_FILE_LIST', fileListType: A}}
 */
const finishLoadingFileList = (fileListType) => ({
  type: FINISH_LOADING_FILE_LIST,
  fileListType,
})

/**
 * @return {{ type: 'START_LOADING_FILE_LIST', fileListType: 'PLOTTR_KNOWN_FILES' }}
 */
export const startLoadingPlottrFileList = () => {
  return startLoadingFileList(PLOTTR_KNOWN_FILES)
}
/**
 * @return {{ type: 'FINISH_LOADING_FILE_LIST', fileListType: 'PLOTTR_KNOWN_FILES' }}
 */
export const finishLoadingPlottrFileList = () => {
  return finishLoadingFileList(PLOTTR_KNOWN_FILES)
}

/**
 * @return {{ type: 'START_LOADING_FILE_LIST', fileListType: 'PRO_KNOWN_FILES' }}
 */
export const startLoadingProFileList = () => {
  return startLoadingFileList(PRO_KNOWN_FILES)
}
/**
 * @return {{ type: 'FINISH_LOADING_FILE_LIST', fileListType: 'PRO_KNOWN_FILES' }}
 */
export const finishLoadingProFileList = () => {
  return finishLoadingFileList(PRO_KNOWN_FILES)
}

// File states
/**
 * @return {{ type: 'START_CHECKING_FILE_TO_LOAD' }}
 */
export const startCheckingFileToLoad = () => ({
  type: START_CHECKING_FILE_TO_LOAD,
})
/**
 * @return {{ type: 'FINISH_CHECKING_FILE_TO_LOAD' }}
 */
export const finishCheckingFileToLoad = () => ({
  type: FINISH_CHECKING_FILE_TO_LOAD,
})
/**
 * @return {{ type: 'START_CREATING_CLOUD_FILE' }}
 */
export const startCreatingCloudFile = () => ({
  type: START_CREATING_CLOUD_FILE,
})
/**
 * @return {{ type: 'FINISH_CREATING_CLOUD_FILE' }}
 */
export const finishCreatingCloudFile = () => ({
  type: FINISH_CREATING_CLOUD_FILE,
})
/**
 * @return {{ type: 'START_UPLOADING_FILE_TO_CLOUD' }}
 */
export const startUploadingFileToCloud = () => ({
  type: START_UPLOADING_FILE_TO_CLOUD,
})
/**
 * @return {{ type: 'FINISH_UPLOADING_FILE_TO_CLOUD' }}
 */
export const finishUploadingFileToCloud = () => ({
  type: FINISH_UPLOADING_FILE_TO_CLOUD,
})
/**
 * @return {{ type: 'START_LOADING_FILE' }}
 */
export const startLoadingFile = () => ({
  type: START_LOADING_FILE,
})
/**
 * @return {{ type: 'FINISH_LOADING_FILE' }}
 */
export const finishLoadingFile = () => ({
  type: FINISH_LOADING_FILE,
})
/**
 * @param {boolean} needToUpdate
 * @return {{ type: 'ERROR_LOADING_FILE', errorIsUpdateError: boolean }}
 */
export const errorLoadingFile = (needToUpdate) => ({
  type: ERROR_LOADING_FILE,
  errorIsUpdateError: needToUpdate,
})
/**
 * @return {{ type: 'CLEAR_ERROR_LOADING_FILE' }}
 */
export const clearErrorLoadingFile = () => ({
  type: CLEAR_ERROR_LOADING_FILE,
})
/**
 * @return {{ type: 'START_RENAMING_FILE' }}
 */
export const startRenamingFile = () => ({
  type: START_RENAMING_FILE,
})
/**
 * @return {{ type: 'FINISH_RENAMING_FILE' }}
 */
export const finishRenamingFile = () => ({
  type: FINISH_RENAMING_FILE,
})
/**
 * @return {{ type: 'START_DELETING_FILE' }}
 */
export const startDeletingFile = () => ({
  type: START_DELETING_FILE,
})
/**
 * @return {{ type: 'FINISH_DELETING_FILE' }}
 */
export const finishDeletingFile = () => ({
  type: FINISH_DELETING_FILE,
})
/**
 * @return {{ type: 'START_SAVING_FILE_AS' }}
 */
export const startSavingFileAs = () => ({
  type: START_SAVING_FILE_AS,
})
/**
 * @return {{ type: 'FINISH_SAVING_FILE_AS' }}
 */
export const finishSavingFileAs = () => ({
  type: FINISH_SAVING_FILE_AS,
})
/**
 * @return {{ type: 'NO_FILE_TO_SHOW' }}
 */
export const noFileToShow = () => ({
  type: NO_FILE_TO_SHOW,
})

// Session states
/**
 * @return {{ type: 'START_LOGGING_IN' }}
 */
export const startLoggingIn = () => ({
  type: START_LOGGING_IN,
})
/**
 * @return {{ type: 'FINISH_LOGGING_IN' }}
 */
export const finishLoggingIn = () => ({
  type: FINISH_LOGGING_IN,
})
/**
 * @return {{ type: 'START_CHECKING_SESSION' }}
 */
export const startCheckingSession = () => ({
  type: START_CHECKING_SESSION,
})
/**
 * @return {{ type: 'FINISH_CHECKING_SESSION' }}
 */
export const finishCheckingSession = () => ({
  type: FINISH_CHECKING_SESSION,
})

/**
 * @typedef {'plottrLicense' | 'trial' | 'proSubscription'} LicenseType
 */

// License states
/**
 * @param {LicenseType} licenseType
 * @return {{ type: 'START_LOADING_A_LICENSE_TYPE', licenseType: LicenseType }}
 */
export const startLoadingALicenseType = (licenseType) => ({
  type: START_LOADING_A_LICENSE_TYPE,
  licenseType,
})
/**
 * @param {LicenseType} licenseType
 * @return {{ type: 'FINISH_LOADING_A_LICENSE_TYPE', licenseType: LicenseType }}
 */
export const finishLoadingALicenseType = (licenseType) => ({
  type: FINISH_LOADING_A_LICENSE_TYPE,
  licenseType,
})

/**
 * @typedef {'exportConfig' | 'settings'} SettingsType
 */

// Settings states
/**
 * @param {SettingsType} settingsType
 * @return {{ type: 'START_LOADING_A_SETTINGS_TYPE', settingsType: SettingsType }}
 */
export const startLoadingASettingsType = (settingsType) => ({
  type: START_LOADING_A_SETTINGS_TYPE,
  settingsType,
})
/**
 * @param {SettingsType} settingsType
 * @return {{ type: 'FINISH_LOADING_A_SETTINGS_TYPE', settingsType: SettingsType }}
 */
export const finishLoadingASettingsType = (settingsType) => ({
  type: FINISH_LOADING_A_SETTINGS_TYPE,
  settingsType,
})

// Settings Wizard
/**
 * @return {{ type: 'ADVANCE_SETTINGS_WIZARD' }}
 */
export const advanceSettingsWizard = () => ({
  type: ADVANCE_SETTINGS_WIZARD,
})
/**
 * @return {{ type: 'REGRESS_SETTINGS_WIZARD' }}
 */
export const regressSettingsWizard = () => ({
  type: REGRESS_SETTINGS_WIZARD,
})
/**
 * @return {{ type: 'START_SETTINGS_WIZARD' }}
 */
export const startSettingsWizard = () => ({
  type: START_SETTINGS_WIZARD,
})
/**
 * @return {{ type: 'FINISH_PRO_ONBOARDING_HAVING_CHOSEN_PRO' }}
 */
export const finishProOnboardingHavingChosenPro = () => ({
  type: FINISH_PRO_ONBOARDING_HAVING_CHOSEN_PRO,
})
/**
 * @return {{ type: 'FINISH_SETTINGS_WIZARD' }}
 */
export const finishSettingsWizard = () => ({
  type: FINISH_SETTINGS_WIZARD,
})

// Pro Onboarding
/**
 * @return {{ type: 'ADVANCE_PRO_ONBOARDING' }}
 */
export const advanceProOnboarding = () => ({
  type: ADVANCE_PRO_ONBOARDING,
})
/**
 * @return {{ type: 'START_ONBOARDING' }}
 */
export const startProOnboarding = () => ({
  type: START_ONBOARDING,
})
/**
 * @return {{ type: 'FINISH_ONBOARDING' }}
 */
export const finishProOnboarding = () => ({
  type: FINISH_ONBOARDING,
})
/**
 * @return {{ type: 'CANCEL_ONBOARDING' }}
 */
export const cancelProOnboarding = () => ({
  type: CANCEL_ONBOARDING,
})
/**
 * @return {{ type: 'START_ONBOARDING_FROM_ROOT' }}
 */
export const startProOnboardingFromRoot = () => ({
  type: START_ONBOARDING_FROM_ROOT,
})

/**
 * @param {boolean} forceLicenseCheck
 * @return {{ type: 'SET_FORCE_LICENSE_CHECK', forceLicenseCheck: boolean }}
 */
export const setForceLicenseCheck = (forceLicenseCheck) => {
  return { type: SET_FORCE_LICENSE_CHECK, forceLicenseCheck }
}

// Import
/**
 * @return {{ type: 'START_IMPORTING_SCRIVENER' }}
 */
export const startScrivenerImporter = () => ({
  type: START_IMPORTING_SCRIVENER,
})

/**
 * @return {{ type: 'START_FILE_IMPORT' }}
 */
export const startProjectImporter = () => ({
  type: START_FILE_IMPORT,
})

/**
 * @return {{ type: 'FINISH_IMPORTING_SCRIVENER' }}
 */
export const finishScrivenerImporter = () => ({
  type: FINISH_IMPORTING_SCRIVENER,
})

/**
 * @return {{ type: 'FINISH_FILE_IMPORT' }}
 */
export const finishProjectImporter = () => ({
  type: FINISH_FILE_IMPORT,
})

/**
 * @param {String} filePath
 * @return {{ type: 'PROMPT_TO_UPLOAD_FILE', filePath: String }}
 */
export const promptToUploadFile = (filePath) => ({
  type: PROMPT_TO_UPLOAD_FILE,
  filePath,
})

/**
 * @return {{ type: 'DISMISS_PROMPT_TO_UPLOAD_FILE' }}
 */
export const dismissPromptToUploadFile = () => ({
  type: DISMISS_PROMPT_TO_UPLOAD_FILE,
})

// Updates
/**
 * @return {{ type: 'REQUEST_CHECK_FOR_UPDATE' }}
 */
export const requestCheckForUpdates = () => ({
  type: REQUEST_CHECK_FOR_UPDATE,
})

/**
 * @return {{ type: 'AUTO_CHECK_FOR_UPDATES' }}
 */
export const autoCheckForUpdates = () => ({
  type: AUTO_CHECK_FOR_UPDATES,
})

/**
 * @param {boolean} available
 * @param {String | null} error
 * @param {UpdateInfo} info
 * @return {{ type: 'PROCESS_RESPONSE_TO_REQUEST_UPDATE', available: boolean, error: String | null, info: UpdateInfo }}
 */
export const processResponseToRequestUpdate = (available, error, info) => ({
  type: PROCESS_RESPONSE_TO_REQUEST_UPDATE,
  available,
  error,
  info,
})

/**
 * @return {{ type: 'DISMISS_UPDATE_NOTIFIER' }}
 */
export const dismissUpdateNotifier = () => ({
  type: DISMISS_UPDATE_NOTIFIER,
})

/**
 * @param {number} percent
 * @return {{ type: 'SET_UPDATE_DOWNLOAD_PROGRESS', percent: number }}
 */
export const setUpdateDownloadProgress = (percent) => ({
  type: SET_UPDATE_DOWNLOAD_PROGRESS,
  percent,
})

/**
 * @return {{ type: 'DIFFICULTY_CONTACTING_LICENSING_API' }}
 */
export const difficultyContactingLicensingAPI = () => {
  return {
    type: DIFFICULTY_CONTACTING_LICENSING_API,
  }
}

/**
 * @return {{ type: 'BUSY_WITH_WORK_THAT_PREVENTS_QUITTING' }}
 */
export const startWorkThatPreventsQuitting = () => ({
  type: BUSY_WITH_WORK_THAT_PREVENTS_QUITTING,
})

/**
 * @return {{ type: 'DONE_WITH_WORK_THAT_PREVENTS_QUITTING' }}
 */
export const finishWorkThatPreventsQuitting = () => ({
  type: DONE_WITH_WORK_THAT_PREVENTS_QUITTING,
})

/**
 * @return {{ type: 'INCREMENT_JUMP_COUNTER' }}
 */
export const incrementJumpCounter = () => {
  return {
    type: INCREMENT_JUMP_COUNTER,
  }
}

/**
 * @return {{ type: 'START_EDITING' }}
 */
export const startEditing = () => {
  return {
    type: START_EDITING,
  }
}

/**
 * @return {{ type: 'START_VIEWING' }}
 */
export const startViewing = () => {
  return {
    type: START_VIEWING,
  }
}

/**
 * @return {{ type: 'START_SEARCHING' }}
 */
export const startSearching = () => {
  return {
    type: START_SEARCHING,
  }
}

/**
 * @param {Locale} language
 * @return {{ type: 'STAGE_LANGUAGE', language: Locale }}
 */
export const stageLanguage = (language) => ({
  type: STAGE_LANGUAGE,
  language,
})

/**
 * @param {String} filePath
 * @return {{ type: 'SET_PATH_TO_PROJECT', filePath: String }}
 */
export const setPathToProject = (filePath) => {
  return {
    type: SET_PATH_TO_PROJECT,
    filePath,
  }
}

/**
 * @param {'backups'} view
 * @return {{ type: 'OPEN_DASHBOARD_TO', view: 'backups' }}
 */
export const setOpenDashboardTo = (view) => {
  return {
    type: OPEN_DASHBOARD_TO,
    view,
  }
}

/**
 * @return {{ type: 'DASHBOARD_CLOSED' }}
 */
export const dashboardClosed = () => {
  return {
    type: DASHBOARD_CLOSED,
  }
}

/**
 * @return {{ type: 'FINISH_FIRST_TIME_BOOTING' }}
 */
export const finishFirstTimeBooting = () => {
  return {
    type: FINISH_FIRST_TIME_BOOTING,
  }
}

/**
 * @return {{ type: 'START_QUITTING' }}
 */
export const startQuitting = () => {
  return {
    type: START_QUITTING,
  }
}

/**
 * @param {FileURL} fileURL
 * @return {{ type: 'RECORD_FILE_URL_BOOTED_WITH', fileURL: String }}
 */
export const recordFileURLBootedWith = (fileURL) => {
  return {
    type: RECORD_FILE_URL_BOOTED_WITH,
    fileURL,
  }
}

/**
 * @return {{ type: 'RECEIVED_WINDOW_STATE' }}
 */
export const receivedWindowState = () => {
  return {
    type: RECEIVED_WINDOW_STATE,
  }
}

/**
 * @param {boolean} isOnline
 * @return {{ type: 'SET_ONLINE', isOnline: boolean }}
 */
export const setOnline = (isOnline) => {
  return {
    type: SET_ONLINE,
    isOnline,
  }
}

/**
 * @return {{ type: 'ASK_TO_RECONNECT' }}
 */
export const askToReconnect = () => {
  return {
    type: ASK_TO_RECONNECT,
  }
}

/**
 * @return {{ type: 'ASK_TO_LOGIN' }}
 */
export const askToLogin = () => {
  return {
    type: ASK_TO_LOGIN,
  }
}

/**
 * @param {number} percentageCompleted
 * @param {String} description
 * @return {{ type: 'ADVANCE_BOOTING_DISPLAY_STATE', percentageCompleted: number, description: string }}
 */
export const advanceBootingDisplayState = (percentageCompleted, description) => {
  return {
    type: ADVANCE_BOOTING_DISPLAY_STATE,
    percentageCompleted,
    description,
  }
}

/**
 * @param {'trial' | 'plottrLicense' | 'proSubscription'} licenseType
 * @return {{ type: 'START_FETCHING_A_LICENSE_TYPE', licenseType: 'trial' | 'plottrLicense' | 'proSubscription' }}
 */
export const startFetchingALicenseType = (licenseType) => {
  return {
    type: START_FETCHING_A_LICENSE_TYPE,
    licenseType,
  }
}

/**
 * @param {'trial' | 'plottrLicense' | 'proSubscription'} licenseType
 * @return {{ type: 'FINISH_FETCHING_A_LICENSE_TYPE', licenseType: 'trial' | 'plottrLicense' | 'proSubscription' }}
 */
export const finishFetchingALicenseType = (licenseType) => {
  return {
    type: FINISH_FETCHING_A_LICENSE_TYPE,
    licenseType,
  }
}
